import {OBJECT_ADMIN, NOTIFICATIONS} from '../../../endpoints'
import {apiPrivate, apiPublic} from '../../../api'
import types from '../types/help'
import {endpoint as endpointText} from '../../../common/text'
import {push} from 'react-router-redux'
import {ApiError} from '../../activity/schemas'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class help {

  static fetchCategories() {
    return dispatch => {

      dispatch({type: types.FETCH_CATEGORIES})

      return apiPrivate.get(OBJECT_ADMIN + '/faqCategory')
        .then(response => {

          let categories = response.data.description.categories
          if (!categories) categories = []

          dispatch({
            type: types.FETCH_CATEGORIES_SUCCESS,
            payload: {
              categories,
            },
          })
          return true
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.FETCH_CATEGORIES_FAIL, payload: {error: message}})
              return false
            }
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.FETCH_CATEGORIES_FAIL, payload: {error: message}})
          return false
        })
    }
  }

  static fetchFaqs(categoryID) {
    return dispatch => {

      if (categoryID === 0) return

      dispatch({
        type: types.FETCH_FAQS,
        payload: {
          categoryID,
        },
      })

      return apiPrivate.get(OBJECT_ADMIN + '/faq?category=' + categoryID)
        .then(response => {

          let faqs = response.data.description.faqs
          if (!faqs) faqs = []

          dispatch({
            type: types.FETCH_FAQS_SUCCESS,
            payload: {
              faqs,
            },
          })
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch({type: types.FETCH_FAQS_FAIL, payload: {error: message}})
              return
            }
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.FETCH_FAQS_FAIL, payload: {error: message}})
        })
    }
  }

  static sendContactMessage() {
    return (dispatch, getState) => {

      const state = getState().ui.help.help

      const userID = getState().domain.user.id
      const name = state.get('name')
      const email = state.get('email')
      const message = state.get('message')

      if (name === '' || email === '' || message === '')
        return Promise.resolve(false)

      dispatch({type: types.SEND_MESSAGE})

      const formData = new FormData()
      formData.append('id', userID)
      formData.append('name', name)
      formData.append('email', email)
      formData.append('message', message)

      return apiPublic.post(NOTIFICATIONS + '/notifications/contact', formData)
        .then(response => {
          dispatch({type: types.SEND_MESSAGE_SUCCESS})
          return true
        })
        .catch(error => {
          let message = ''
          if (error.response) {
            const response = new ApiError(error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch({type: types.SEND_MESSAGE_FAIL, payload: {error: message}})
          return false
        })
    }
  }

  static setName(name) {
    return {
      type: types.SET_NAME,
      payload: {
        name,
      },
    }
  }

  static setEmail(email) {
    return {
      type: types.SET_EMAIL,
      payload: {
        email,
      },
    }
  }

  static setMessage(message) {
    return {
      type: types.SET_MESSAGE,
      payload: {
        message,
      },
    }
  }

  static setShowContactSuccessMessage(show) {
    return {
      type: types.SET_SHOW_CONTACT_SUCCESS_MESSAGE,
      payload: {
        show,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/help/actions/help.js